//#region types
import { EventConstants, IconDefinitionConstants, ReportConstants } from "utils/constants";
import { CommonEnums, DialogEnums } from "models/enums";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import DocumentCreateFormContainer from "./createFormContainer";
import useCreateSuccessMessages from "./useCreateSuccessMessages";
//#endregion
import { EventHelper, LocalizationHelperInstance } from "utils/helpers";

function useCreateDocumentDialog(onCreateSuccess?: () => void, refreshReportsOnSucess?: boolean) {
  const { enqueueMessageByDocumentType } = useCreateSuccessMessages();

  const onDocumentCreateSuccess = (values: { type?: CommonEnums.DocumentTypes }) => {
    enqueueMessageByDocumentType(values.type);

    onCreateSuccess && onCreateSuccess();

    if (refreshReportsOnSucess) {
      let reportKey;
      switch (values.type) {
        case CommonEnums.DocumentTypes.GenericDocument:
          reportKey = ReportConstants.ReportKeys.GenericDocuments;
          break;
        case CommonEnums.DocumentTypes.Receipt:
          reportKey = ReportConstants.ReportKeys.Receipt;
          break;
        case CommonEnums.DocumentTypes.SIEFiles:
          reportKey = ReportConstants.ReportKeys.SIE;
          break;
        case CommonEnums.DocumentTypes.SelfInvoice:
          reportKey = ReportConstants.ReportKeys.Invoice;
          break;
      }

      if (reportKey !== undefined) {
        EventHelper.publishEvent(EventHelper.getDynamicEventName(EventConstants.RefreshReport, reportKey));
      }
    }
  };

  const dialog: DialogProps = {
    isOpen: false,
    id: "createDocument",
    title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Document.AddDocument),
    titleIcon: IconDefinitionConstants.WDocument,
    actions: [
      {
        text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Submit),
      },
    ],
    dialogType: DialogEnums.DialogType.Content,
    children: <DocumentCreateFormContainer />,
    maxWidth: "sm",
    onSubmit: onDocumentCreateSuccess,
  };

  return dialog;
}

export default useCreateDocumentDialog;
